import { Component, Injector, Input, ViewChild } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'md-document-check-your-inbox',
  template: require('./document-check-your-inbox.component.html'),
  styles: [require('./document-check-your-inbox.component.scss')]
})
export class DocumentCheckYourInboxComponent extends BaseRoute {
  @Input() form;
  @ViewChild('focusItem') focusItem;

  // eslint-disable-next-line no-useless-constructor
  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    this.appActions.setData('stepUserIsOn', 0);
    if (this.focusItem) {
      this.focusItem.nativeElement.focus();
    }
  }

  btnClick(event) {
    if (event.action === 'next') {
      window.location.href = 'https://www.ally.com';
    } else {
      this.router.navigate(['document-uploader'], { queryParamsHandling: 'preserve' });
    }
  }

}
